<template>
  <VueTypeaheadBootstrap
    v-model="search"
    :data="counties"
    :serializer="(item) => item.state_initials + '/' + item.name"
    :placeholder="placeholder"
    @input="findCounty"
    @hit="county = $event"
    class="form-control form-control-custom"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";
import { debounce } from "lodash";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/esm/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/esm/mixins/form-state";

import { sortKeys } from "bootstrap-vue/esm/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/esm/utils/props";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {},
    placeholder: {
      type: String,
      default: "Buscar  ...",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    county: null,
    search: "",
    counties: [],
  }),
  computed: {},
  methods: {
    ...mapActions("counties", ["ActionFind", "ActionFindById"]),
    findCounty: debounce(async function () {
      var counties = await this.ActionFind(this.search);
      this.counties = counties;
    }, 500),

    async setCountyByIbge(ibge) {
      if (ibge) {
        this.county = await this.ActionFindById(ibge);
      }
    },
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.county = null;
      }
    },
    county: function () {
      if (this.county) {
        this.search = this.county.name;
        this.counties = [this.county];
        this.$emit("input", this.county.id);
      } else {
        this.$emit("input", null);
      }
    },
    value: function (value) {
      this.setCountyByIbge(value);
    },
  },
  async created() {
    if (this.value) {
      this.setCountyByIbge(this.value);
    }
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0;
  padding-left: 0;
  padding-top: 0;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}
</style>
